var map = {
	"./brain_0-2.png": "a240",
	"./brain_1-2.png": "5e4b",
	"./brain_10-2.png": "ea71",
	"./brain_11-2.png": "51f1",
	"./brain_12-2.png": "672e",
	"./brain_13-2.png": "cdb6",
	"./brain_14-2.png": "c09d",
	"./brain_15-2.png": "670d",
	"./brain_16-2.png": "c235",
	"./brain_17-2.png": "8a1e",
	"./brain_18-2.png": "8e16",
	"./brain_19-2.png": "3a3b",
	"./brain_2-2.png": "0e00",
	"./brain_20-2.png": "1171",
	"./brain_3-2.png": "c578",
	"./brain_4-2.png": "6907",
	"./brain_5-2.png": "8e59",
	"./brain_6-2.png": "bce1",
	"./brain_7-2.png": "f2a0",
	"./brain_8-2.png": "8912",
	"./brain_9-2.png": "5f69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a729";